export default __webpack_public_path__ + "static/media/Deepiq_chart (1).a924f178.png";